import { HttpHandler } from 'msw'

import { unlockHatch } from './unlockHatch'

export const hatch: HttpHandler[] = [unlockHatch]
